module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "interupt",
    attrs: {
      "id": "interupt"
    }
  }, [(_vm.type === 'regular') ? _c('div', {
    staticClass: "interupt-regular"
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun"
  }, [_c('div', {
    staticClass: "fun-item fun-sun hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-camera bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-key bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-squares hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crop bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-levers hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crown bigEntrance"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "cell-content"
  }, [_c('div', {
    staticClass: "the-text",
    domProps: {
      "innerHTML": _vm._s(_vm.interupt)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-butt",
    on: {
      "click": function($event) {
        _vm.$store.commit('interupt', null)
      }
    }
  }, [_vm._v("Ok")])])])]) : _vm._e(), _vm._v(" "), (_vm.type === 'win') ? _c('div', {
    staticClass: "interupt-win"
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun"
  }, [_c('div', {
    staticClass: "fun-item fun-sun hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-happy-green bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crop bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-levers hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crown bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-happy-yellow bigEntrance"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "cell-content"
  }, [_c('div', {
    staticClass: "the-text",
    domProps: {
      "innerHTML": _vm._s(_vm.interupt)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-butt",
    on: {
      "click": function($event) {
        _vm.$store.commit('interupt', null)
      }
    }
  }, [_vm._v("Ok")])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b5e0b96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Interupt.vue
// module id = 117
// module chunks = 0